import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';

import { PlayerDetailsRaces } from '../../service/player.service';

@Component({
    selector: 'app-member-race-history',
    standalone: true,
    templateUrl: './memberRaceHistory.component.html',
    styleUrls: ['./memberRaceHistory.component.scss'],
    imports: [CommonModule, TableModule, TagModule, ButtonModule],
})
export class MemberRaceHistoryComponent {
    private _races: PlayerDetailsRaces[] = [];
    /** Date-desc copy for the mobile card list; presorted here so getters stay cheap. */
    sortedRaces: PlayerDetailsRaces[] = [];
    visibleCount = 10;

    @Input()
    set races(value: PlayerDetailsRaces[]) {
        this._races = value ?? [];
        this.sortedRaces = [...this._races].sort((a, b) => (b.day_real ?? '').localeCompare(a.day_real ?? ''));
        this.visibleCount = 10;
    }
    get races(): PlayerDetailsRaces[] {
        return this._races;
    }

    /** Heading shown above the table; overridable for the public player page. */
    @Input() title = 'Deine Rennen';

    get visibleRaces(): PlayerDetailsRaces[] {
        return this.sortedRaces.slice(0, this.visibleCount);
    }

    get hasMore(): boolean {
        return this.sortedRaces.length > this.visibleCount;
    }

    showMore(): void {
        this.visibleCount += 10;
    }

    /** PrimeNG tag severity for a finishing position (podium colours). */
    positionSeverity(position?: number): 'success' | 'warn' | 'info' | 'secondary' {
        if (position === 1) return 'success';
        if (position === 2 || position === 3) return 'warn';
        if (position != null && position <= 10) return 'info';
        return 'secondary';
    }
}
